import React, { useEffect, useContext } from "react";

import { Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import { GridStyled } from "../../styles/GlobalStyle";
import FormCustomer from "./children/FormCustomer";
import FormProduct from "./children/FormProduct";
import FormPromocode from "./children/FormPromocode";
import { getPromoters } from "../../repositories/promoterRepository";
import {
  CustomerContextProvider,
  CustomerContext,
} from "./contexts/CustomerContext";
import ModalLoading from "../../components/modalLoading/ModalLoading";

function Page({ location }) {
  const { loadings, setLoadings, setPromoters } = useContext(CustomerContext);
  const { push } = useHistory();

  useEffect(() => {
    (async () => {
      try {
        setLoadings((current) => ({ ...current, promoters: true }));

        const { data: respPromoters } = await getPromoters({});

        if (Array.isArray(respPromoters?.data))
          setPromoters(respPromoters.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadings((current) => ({ ...current, promoters: false }));
      }
    })();
  }, [setLoadings, setPromoters]);

  return (
    <>
      <ModalLoading loading={!!loadings.screen} />
      <Container maxWidth="lg">
        <GridStyled
          container
          padding="0 0 20px 0"
          justify="space-between"
          spacing={3}
        >
          <Grid item container>
            <IconButton onClick={() => push("/clients")}>
              <Tooltip title="Voltar">
                <ArrowBackIcon />
              </Tooltip>
            </IconButton>
          </Grid>
          <FormCustomer state={location?.state} />

          <FormPromocode />

          <FormProduct state={location?.state} />
        </GridStyled>
      </Container>
    </>
  );
}

function UpdateCustomer({ location }) {
  return (
    <CustomerContextProvider>
      <Page location={location} />
    </CustomerContextProvider>
  );
}

export default UpdateCustomer;
